import { SkeletonPageHeader, SkeletonPanel, SkeletonRect, SkeletonText, SkeletonTextLines } from '../Skeleton';

// =============================================================================
// H9 > 앱 연동 skeleton.
// Mirrors: 2-pane layout with left app list + right app info / connection cards.
// =============================================================================

export function AppIntegrationsSkeleton(): JSX.Element {
  return (
    <div className="h-full overflow-auto p-6">
      <SkeletonPageHeader />

      <div className="flex items-start gap-4">
        {/* Left app list */}
        <aside className="w-[260px] shrink-0">
          <SkeletonPanel header className="p-2">
            <div className="flex flex-col gap-1 p-2">
              <SkeletonText width={80} height="0.85em" className="px-2 py-1" />
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex items-center gap-2 px-2 py-2">
                  <SkeletonRect width={20} height={20} />
                  <SkeletonText width={i % 2 === 0 ? 110 : 140} />
                </div>
              ))}
            </div>
          </SkeletonPanel>
        </aside>

        {/* Right cards */}
        <section className="min-w-0 flex-1 flex flex-col gap-4">
          <SkeletonPanel header>
            <div className="flex flex-col gap-4 p-5">
              <SkeletonTextLines lines={3} widths={['100%', '95%', '70%']} gap={8} />
              <SkeletonRect width={80} height={34} />
              <SkeletonText width={60} height="1em" />
              <div className="flex flex-col gap-3">
                {Array.from({ length: 3 }).map((_, i) => (
                  <div key={i}>
                    <SkeletonText width={200} height="1em" />
                    <SkeletonText width={260} height="0.9em" className="mt-1" />
                  </div>
                ))}
              </div>
            </div>
          </SkeletonPanel>

          <SkeletonPanel header>
            <div className="grid grid-cols-1 gap-4 p-5 sm:grid-cols-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex flex-col gap-1">
                  <SkeletonText width={70} height="0.85em" />
                  <SkeletonText width={180} height="1.1em" />
                </div>
              ))}
            </div>
          </SkeletonPanel>
        </section>
      </div>
    </div>
  );
}
